import * as $ from 'jquery';

export const checkToKeepping = ( $element, $elementBit ): boolean => {
  // console.log($element, $elementBit);
  return $($element[ 0 ]).has($elementBit).length > 0;

};



// WEBPACK FOOTER //
// ./app/helpers/check-to-keeping.ts